import React from 'react';
import './ImageLinkForm.css'

 


const ImageLinkForm = ({ onInputChange, onButtonSubmit }) => {
    return (
        <div >
            <p className='white f3'>
                {'Smart Brain machine will detect faces in your pictures. Give it a try!'}
            </p>
            <div className='center'>
                <div className='center pa4 br3 shadow-5 form'>
                    <input placeholder="Enter image link here" onChange={onInputChange} type='text' className='f4 pa2 w-70 center'/>
                    <button onClick={onButtonSubmit} className='b w-30 grow f4 link ph3 pv2 dib white bg-dark-red'>Detect</button>
                </div>
            </div>
        </div>
    );
}

export default ImageLinkForm;